import { ApiController } from '@yoop/base-client';
import type {
  TokenAssignmentResendResponse,
  TransferAcceptRequest,
  TransferAcceptResponse,
  TransferDeclineRequest,
  TransferRequest,
  TransferResponse,
  TransferRevokeRequest,
} from '@yoop/server-model/token-info';
export class EventTokenController extends ApiController {
  public revokeToken(inventoryItemId: number | string): Promise<Record<string, never>> {
    return this.del('/tokenAssignment/revoke', { inventoryItemId });
  }

  public returnToken(inventoryItemId: number | string): Promise<Record<string, never>> {
    return this.del('/tokenAssignment/return', { inventoryItemId });
  }

  public selfAssignToken(eventId: number | string, tokenId: number | string): Promise<void> {
    return this.put(`/tokenAssignment/selfAssign?globalEventId=${eventId}&tokenId=${tokenId}`);
  }

  public resendInvite(assignmentGroupId: number | string): Promise<TokenAssignmentResendResponse> {
    return this.put(`tokenAssignment/resend?assignmentGroupId=${assignmentGroupId}`);
  }

  public transferTokens(request: TransferRequest): Promise<TransferResponse> {
    return this.post('/transfer/initiate', request);
  }

  public acceptTransferTokens(request: TransferAcceptRequest): Promise<TransferAcceptResponse> {
    return this.post('/transfer/accept', request);
  }
  public revokeTransfer(request: TransferRevokeRequest): Promise<TransferResponse> {
    return this.del('/transfer/revoke', request);
  }
  public declineTransfer(request: TransferDeclineRequest): Promise<TransferResponse> {
    return this.del('/transfer/public/decline', request);
  }
}
